import type { ReactNode } from 'react';
import { DS2 } from '../../theme/designTokens';

/**
 * DS2 Auth-family body copy — Roboto 300 30px ×0.75 → 22.5px. Extracted
 * from ForgotPasswordScreen. Figma's own line-height varies per frame
 * (e.g. 59px on "reset password" vs 44px on "create new password") because
 * those paragraphs sit in a wider box than this family's 363px card; kept
 * to the narrower ratio (44px×0.75 = 33px) here so text reflowed into this
 * column doesn't look loose.
 */
export function AuthBody({ children }: { children: ReactNode }) {
  return (
    <p
      style={{
        margin:     '16px 0 0',
        fontFamily: DS2.font.body,
        fontWeight: 300,
        fontSize:   22.5,
        lineHeight: '33px',
        textAlign:  'center',
        color:      DS2.color.textBright,
      }}
    >
      {children}
    </p>
  );
}
